
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.777 7.253l-2.033-2.032-2.032 2.032a.747.747 0 101.057 1.058l.203-.203a5.998 5.998 0 01-5.985 5.67 6.033 6.033 0 01-5.183-2.97.749.749 0 00-1.027-.27.749.749 0 00-.27 1.028 7.544 7.544 0 006.48 3.712c4.035 0 7.327-3.21 7.485-7.207l.232.232c.15.15.338.218.533.218a.747.747 0 00.533-1.275l.007.007zM4.277 7.253a.747.747 0 00-1.058 0l-.202.203a5.998 5.998 0 015.985-5.67 5.953 5.953 0 015.07 2.797.745.745 0 001.035.233.745.745 0 00.232-1.035A7.473 7.473 0 008.994.286c-4.035 0-7.327 3.21-7.485 7.207l-.232-.232A.747.747 0 10.219 8.318l2.033 2.033 2.032-2.033a.747.747 0 000-1.057l-.007-.008z","fill":"#262626"}}),_c('path',{attrs:{"d":"M9.744 4.036h-1.5a.752.752 0 00-.75.75c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75a.752.752 0 00-.75-.75zM9.744 7.036h-1.5a.752.752 0 00-.75.75c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75a.752.752 0 00-.75-.75zM9.744 10.036h-1.5a.752.752 0 00-.75.75c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75a.752.752 0 00-.75-.75z","fill":"#262626"}})])
          )
        }
      }
    